module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms-jump-ad"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/1_01.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number-wrap"
  }, [_c('div', {
    staticClass: "count"
  }, _vm._l((_vm.joinedCountArr), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "count-item",
      attrs: {
        "src": item
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "hint"
  }, [_vm._v("众测参与人数")])])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isJoined),
      expression: "!isJoined"
    }],
    attrs: {
      "src": require("../../assets/images/1_02.jpg"),
      "alt": ""
    },
    on: {
      "click": _vm.check
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isJoined),
      expression: "isJoined"
    }],
    attrs: {
      "src": require("../../assets/images/2_02_1.png"),
      "alt": ""
    },
    on: {
      "click": _vm.toCoupon
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/2_03.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/2_04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/2_05.png"),
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-254b7a6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/index/App.vue
// module id = 77
// module chunks = 1